import instance from "./instance.js";
import { base } from "./config.js";
import { message } from "antd";
import qs from "qs";

/**
 * 管理员登录
 * @param {Object} parm 请求参数
 * @param {String} parm.email 邮箱
 * @param {String} parm.password 密码
 * @returns
 */
export const LOGIN = async (parm) =>
  await instance.post(`${base}/api/login/login`, parm);

/**
 * 管理员注册
 * @param {Object} parm 请求参数
 * @param {String} parm.username 姓
 * @param {String} parm.nickname 名
 * @param {String} parm.email 邮箱
 * @param {String} parm.code 邮箱验证码
 * @param {String} parm.password 密码
 * @returns
 */
export const REGISTER = async (parm) =>
  await instance.post(`${base}/api/login/register`, parm);

/**
 * 重置密码
 * @param {Object} parm 请求参数
 * @param {String} parm.email 邮箱
 * @param {String} parm.code 邮箱验证码
 * @param {String} parm.password 密码
 * @returns
 */
export const REPASSWORD = async (parm) =>
  await instance.post(`${base}/api/login/repassword`, parm);

/**
 * 获取邮箱码
 * @param {String} parm.email 邮箱
 * @param {String} parm.code_type 验证码类型:注册register,重置密码password,找回密码retrieve
 * @returns
 */
export const GET_EMAIL_CODE = async (parm) =>
  await instance.post(`${base}/api/login/code`, parm);

/**
 * 管理员信息
 * @returns
 */
export const GET_ADMIN_INFO = async () =>
  await instance.get(`${base}/api/admin/info`);

/**
 * 管理员刷新token
 * @returns
 */
export const REFRESH_ADMIN_TOKEN = async (parm) =>
  await instance.post(`${base}/api/admin/refresh`, parm);

/**
 * 管理员退出
 * @returns
 */
export const LOGIN_OUT = async (parm) =>
  await instance.post(`${base}/api/admin/logout`, parm);

export default {
  //重置密码
  async resetPwd(params) {
    return await instance
      .post(`${base}/public/reset_pwd`, params)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        message.error("服务器出错");
      });
  },
};
